enum SPECIFIC_ERROR_CODES {
  INVOICE_ALREADY_PAID = 'Reverse.Claim.Errors.ClaimGroup.InvoiceAlreadyPaid',
  INVALID_EMAIL_ADDRESS = 'InvalidEmailAddress',
  INCONSISTENT_CARRIER_CONFIGURATION_FOR_SIMPLE_MODE = 'Reverse.Common.Errors.ConsoleSimpleMode.' +
    'InconsistentCarrierConfigurationForSimpleMode',
  INCONSISTENT_WARRANTY_CONFIGURATION_FOR_SIMPLE_MODE = 'Reverse.Common.Errors.ConsoleSimpleMode.' +
    'InconsistentWarrantyConfigurationForSimpleMode',
}

export default SPECIFIC_ERROR_CODES;
